export default __webpack_public_path__ + "static/media/04.9393c7ef.png";